import { Link } from "react-router-dom";

export default function ComingSoon() {
  return (
    <div className="flex flex-col items-center justify-center text-center py-20">
      <span className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
        <i className="ri-tools-line text-2xl"></i>
      </span>
      <h1 className="mt-5 text-xl md:text-2xl font-bold text-foreground-950">Bu bölüm yakında hazır</h1>
      <p className="mt-2 text-sm md:text-base text-foreground-600 max-w-md">
        Bu sayfayı şu anda geliştiriyoruz. Ana panel üzerinden çalışmalarına devam edebilirsin.
      </p>
      <Link
        to="/ogrenci"
        className="mt-6 whitespace-nowrap px-5 py-2.5 rounded-md text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
      >
        Ana Panele Dön
      </Link>
    </div>
  );
}